<div class="policy-content">
  <h1>Política de Privacidade</h1>
  <p class="last-update">Última atualização: {{ currentDate }}</p>

  <section class="policy-section">
    <h2>1. Introdução</h2>
    <p>
      Bem-vindo à nossa plataforma de agendamento de consultas e exames médicos. Levamos sua privacidade a sério e esta política explica como
      coletamos, usamos e protegemos suas informações pessoais.
    </p>
  </section>

  <section class="policy-section">
    <h2>2. Informações que Coletamos</h2>
    <p>Podemos coletar os seguintes tipos de informações:</p>
    <ul>
      <li>Dados pessoais (nome, CPF, data de nascimento, telefone, e-mail)</li>
      <li>Informações de saúde (especialidade médica, histórico de agendamentos)</li>
      <li>Dados de pagamento (para serviços premium)</li>
      <li>Informações técnicas (endereço IP, tipo de navegador, dados de cookies)</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>3. Como Usamos suas Informações</h2>
    <p>Suas informações são utilizadas para:</p>
    <ul>
      <li>Agendar e gerenciar suas consultas e exames</li>
      <li>Melhorar nossos serviços e experiência do usuário</li>
      <li>Enviar lembretes e comunicações importantes</li>
      <li>Garantir a segurança e prevenir fraudes</li>
      <li>Cumprir obrigações legais relacionadas à saúde</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>4. Compartilhamento de Dados</h2>
    <p>Seus dados podem ser compartilhados com:</p>
    <ul>
      <li>Profissionais de saúde e clínicas parceiras para agendamento</li>
      <li>Processadores de pagamento (quando aplicável)</li>
      <li>Autoridades de saúde quando exigido por lei</li>
    </ul>
    <p>Não vendemos seus dados pessoais a terceiros.</p>
  </section>

  <section class="policy-section">
    <h2>5. Segurança de Dados</h2>
    <p>Implementamos medidas técnicas e organizacionais para proteger seus dados, incluindo:</p>
    <ul>
      <li>Criptografia de dados sensíveis</li>
      <li>Controles de acesso restritos</li>
      <li>Protocolos de segurança de rede</li>
      <li>Processos regulares de auditoria</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>6. Seus Direitos</h2>
    <p>Você tem o direito de:</p>
    <ul>
      <li>Acessar e corrigir seus dados pessoais</li>
      <li>Solicitar a exclusão de seus dados, quando aplicável</li>
      <li>Revogar consentimentos anteriores</li>
      <li>Receber informações sobre o uso de seus dados</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>7. Cookies e Tecnologias Semelhantes</h2>
    <p>
      Utilizamos cookies para melhorar sua experiência, analisar tráfego e personalizar conteúdo. Você pode gerenciar suas preferências de cookies nas
      configurações do navegador.
    </p>
  </section>

  <section class="policy-section">
    <h2>8. Alterações nesta Política</h2>
    <p>Podemos atualizar esta política periodicamente. Notificaremos você sobre mudanças significativas por e-mail ou através de nossos serviços.</p>
  </section>

  <section class="policy-section">
    <h2>9. Contato</h2>
    <p>Para dúvidas sobre esta política ou seus dados pessoais, entre em contato conosco:</p>
    <address>
      Email: contato@possoagendar.com<br />
      Telefone: (74) 3611-1424<br />
      Endereço: R. do Paraiso, 385 - Santo Antonio, Juazeiro - BA, 48903-050
    </address>
  </section>
</div>
